// Nav


// ((Drupal, once) => {

  // Toggle off-canvas start
  let offCanvas = document.querySelector(".off-canvas");
  // Multiple toggle buttons
  let offCanvasToggles = document.querySelectorAll(".menu-toggle");

  for (var i = 0; i < offCanvasToggles.length; i++) {
    offCanvasToggles[i].addEventListener("click", (e) => {
      offCanvas.classList.toggle("open");
      offCanvasToggles.forEach (offCanvasToggle => {
        offCanvasToggle.classList.toggle("open");
        offCanvasToggle.ariaExpanded = offCanvasToggle.ariaExpanded !== 'true';
      });
  
    });
  }
  // Toggle off-canvas end

  // Button submenu-toggle start
  let submenuToggles = document.querySelectorAll(".submenu-toggle");

  for (var i = 0; i < submenuToggles.length; i++) {
    submenuToggles[i].addEventListener("click", (e) => {
      // toggle aria-expanded
      e.target.ariaExpanded = e.target.ariaExpanded !== 'true';
      // selecting parent li of submenuToggle to toggle css class
      let submenuToggleParent = e.target.parentElement; 
      submenuToggleParent.classList.toggle("show-menu");
      // close all other menus if they are in dropdown menu and not parents of e.target
      let submenuToggleParentsToClose = document.querySelectorAll(".dropdown-menu .has-submenu.show-menu");
      submenuToggleParentsToClose.forEach (submenuToggleParentToClose => {
        // if is parent of e.target
        if (submenuToggleParentToClose == submenuToggleParent) {
          return;
        } else if (submenuToggleParentToClose.contains(e.target)) { 
          return;
        } else {
          // remove li show menu
          submenuToggleParentToClose.classList.toggle("show-menu");
          // set button expanded to false
          let nextSubmenuToggle = submenuToggleParentToClose.querySelector('button');
          nextSubmenuToggle.ariaExpanded = nextSubmenuToggle.ariaExpanded !== 'true';
        }
      });
    });
  }
  // Button submenu-toggle end

  // Close dropdown menu when it loses focus
  let dropdownMenu = document.querySelector('.primary-bright-nav');
  dropdownMenu.addEventListener('focusout', (e) => {
    if (! dropdownMenu.contains(e.relatedTarget)) {
      // Focus has left the element
      console.log("Focus has left the dropdownMenu");
      closeSubmenus();
    }
  });

  const closeSubmenus = () => {
    submenuToggles.forEach (submenuToggle => {
      submenuToggle.ariaExpanded = 'false';
      submenuToggle.parentElement.classList.remove('show-menu');
    });	
  }

  const closeOffCanvas = () => {
    offCanvas.classList.remove("open");
    offCanvasToggles.forEach (offCanvasToggle => {
      offCanvasToggle.classList.remove("open");
      offCanvasToggle.ariaExpanded = 'false';
    });
  }

  // Close off canvas on click outside of canvas container
  window.addEventListener('click', (e) => {
    if ( document.querySelector('.off-canvas').contains(e.target) || document.querySelector('.toggle').contains(e.target) ) {
      // console.log("Clicked in offCanvas"); 
      return;
    } else {
      //console.log("Clicked outside offCanvas");
      closeOffCanvas();
    }
  });

  // Close off canvas menu when it loses focus
  let offCanvasMenu = document.querySelector('.off-canvas');
  offCanvasMenu.addEventListener('focusout', (e) => {
    if (! offCanvasMenu.contains(e.relatedTarget) && (! document.querySelector('.toggle').contains(e.relatedTarget))) {
      //console.log("Focus has left offCanvasmenu");
      closeOffCanvas();
    }
  });

// })(Drupal, once);

